import { Account } from '@/domain/usecases'
import { FeatureFlag } from '@/infra/feature-flag/feature-flag'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { LoaderFunctionArgs, redirect } from 'react-router-dom'
import PathConstants from '../path-contants'
import BaseLoader, { DeferFunction } from './base-loader'

export default class FeatureFlagLoader extends BaseLoader {
  constructor(
    account: Account.Model,
    redirectUrl: string,
    featureFlag: FeatureFlag.Key,
    ldClient: LDClient
  ) {
    super(account, redirectUrl, undefined, featureFlag, ldClient)
  }

  async loader({ params }: LoaderFunctionArgs) {
    return this.defer(params)
  }

  async defer(fn: DeferFunction) {
    const account = this.getAccount()
    if (account.onboardingCompleted === false && account.passPlan) {
      return redirect(PathConstants.Routes.ONBOADING.value)
    }

    return super.deferExec(fn)
  }
}
